<template>
    <section class="bg-[#f7f4ef] py-16 text-[#171717] md:py-24">
        <div class="mx-auto max-w-7xl px-5 lg:px-12">
            <div class="grid gap-10 border-t border-black/5 pt-12 lg:grid-cols-3 lg:gap-0">
                <div class="lg:border-r lg:border-black/10 lg:pr-10">
                    <h2 class="font-serif text-2xl uppercase">
                        {{ t.details.about.title }}
                    </h2>

                    <div class="mt-6 space-y-4 text-sm leading-relaxed text-black/70">
                        <p
                            v-for="text in t.details.about.texts"
                            :key="text"
                        >
                            {{ text }}
                        </p>
                    </div>

                    <dl class="mt-7 grid grid-cols-2 gap-x-8 gap-y-3 text-sm">
                        <template
                            v-for="item in t.details.about.params"
                            :key="item.label"
                        >
                            <dt class="text-black/55">
                                {{ item.label }}
                            </dt>

                            <dd class="text-black">
                                {{ item.value }}
                            </dd>
                        </template>
                    </dl>
                </div>

                <div class="lg:border-r lg:border-black/10 lg:px-10">
                    <h2 class="font-serif text-2xl uppercase">
                        {{ t.details.planning.title }}
                    </h2>

                    <div class="mt-8 grid grid-cols-3 gap-6">
                        <button
                            v-for="(floor, index) in t.details.planning.floors"
                            :key="floor.title"
                            type="button"
                            class="group text-center"
                            @click="openFloor(index)"
                        >
                            <div class="relative flex h-64 items-center justify-center rounded-2xl bg-white p-2 transition duration-300 group-hover:bg-white/70">
                                <img
                                    :src="floor.image"
                                    :alt="floor.title"
                                    loading="lazy"
                                    decoding="async"
                                    fetchpriority="low"
                                    class="h-full w-full object-contain transition duration-300 group-hover:scale-105"
                                >

                                <div class="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full border border-black/10 bg-white/80 text-black opacity-0 shadow-sm backdrop-blur transition duration-300 group-hover:opacity-100">
                                    <IconZoom class="h-4 w-4"/>
                                </div>
                            </div>

                            <div class="mt-4 text-sm uppercase tracking-wide text-black/70">
                                {{ floor.title }}
                            </div>
                        </button>
                    </div>
                </div>

                <div class="lg:pl-10">
                    <h2 class="font-serif text-2xl uppercase">
                        {{ t.details.location.title }}
                    </h2>

                    <div class="mt-8 overflow-hidden rounded-2xl border border-black/5 bg-white/60">
                        <MapComponent/>
                    </div>

                    <a
                        :href="homeStore.mapLink"
                        target="_blank"
                        rel="noopener"
                        class="mt-5 flex h-14 items-center justify-center rounded-xl bg-[#c8b79c] px-6 text-sm uppercase tracking-wide text-white transition hover:bg-[#b9a584]"
                    >
                        {{ t.details.location.button }}
                    </a>
                </div>
            </div>
        </div>

        <VueEasyLightbox
            v-if="lightboxMounted"
            :visible="lightboxVisible"
            :imgs="floorLightboxImages"
            :index="lightboxIndex"
            @hide="lightboxVisible = false"
            :move-disabled="true"
        />
    </section>
</template>

<script>
import { defineAsyncComponent } from 'vue';

import { useHomeStore } from '@js/store/homeStore.js';
import MapComponent from '@js/components/MapComponent.vue';
import IconZoom from "@js/components/Icons/IconZoom.vue";

const VueEasyLightbox = defineAsyncComponent(() => import('vue-easy-lightbox'));

export default {
    name: 'DetailsSection',

    components: {
        IconZoom,
        MapComponent,
        VueEasyLightbox,
    },

    data() {
        return {
            lightboxMounted: false,
            lightboxVisible: false,
            lightboxIndex: 0,
        };
    },

    computed: {
        homeStore() {
            return useHomeStore();
        },

        locale() {
            return this.homeStore.getLocale(this.$page);
        },

        t() {
            const translations = this.homeStore.getTranslations(this.locale);

            return this.homeStore.getDetailsWithFloorImages(translations);
        },

        floorLightboxImages() {
            return this.t.details.planning.floors.map((floor) => floor.image);
        },
    },

    methods: {
        openFloor(index) {
            this.lightboxMounted = true;
            this.lightboxIndex = index;
            this.lightboxVisible = true;
        },
    },
};
</script>
